import { Field } from 'react-final-form';
import { Flex, Heading } from 'theme-ui';

import ImageUpload from '@/components/Collection/ImageUpload';

const requiredImage = (value: string) =>
  value ? undefined : 'Image is required';

export type CreativeImage = {
  value: string;
  label: string;
  fieldName: string;
  requiredWidth: number;
  requiredHeight: number;
};

export type CreativeImagesProps = {
  title: string;
  disabled?: boolean;
  images: CreativeImage[];
  pendingFiles?: Map<string, File>;
  onImageChange: (fieldName: string, key: string) => void;
  onFileSelect?: (fieldName: string, file: File | null) => void;
};

/**
 * Split out of CreativeAsset so a form that already knows which markets it is
 * editing can render the uploads on their own. CreativeAsset draws its market
 * grid unconditionally, so reusing it per market would repeat every market.
 */
export default function CreativeImages({
  title,
  images,
  disabled,
  pendingFiles,
  onFileSelect,
  onImageChange,
}: CreativeImagesProps) {
  return (
    <Flex sx={{ p: 6, gap: 3, flex: 1, flexDirection: 'column' }}>
      <Heading variant="headingSm">{title}</Heading>
      {images.map((image) => (
        <Field
          key={image.fieldName}
          name={image.fieldName}
          validate={requiredImage}
        >
          {({ meta }) => {
            const error = (meta.touched && meta.error) || meta.submitError;
            return (
              <ImageUpload
                label={image.label}
                value={image.value}
                disabled={disabled}
                externalError={error}
                requiredWidth={image.requiredWidth}
                requiredHeight={image.requiredHeight}
                onFileSelect={
                  onFileSelect
                    ? (f) => onFileSelect(image.fieldName, f)
                    : undefined
                }
                onChange={(key) => onImageChange(image.fieldName, key)}
                pendingFile={pendingFiles?.get(image.fieldName) ?? null}
              />
            );
          }}
        </Field>
      ))}
    </Flex>
  );
}
